module.exports = __webpack_public_path__ + "img/green-earbuds.8bd27107.jpg";